import { GraphemeFontGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.font";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { MorphemeDetailsTileSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import { usePrevalentPinyin } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.pinyin.prevalence";
import { useGetGraphemeGlyph } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.glyph/client";
import { toDiacriticPinyinList } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";
import { Pressable, View } from "@-/com.npmjs.react-native";

export function DeckPageItemRow({
  graphemeCard,
  isDetailsPending = false,
  isEditing,
  onRemoveCard,
}: {
  graphemeCard: MorphemeDetailsTileSlice;
  /**
   * `graphemeCard` is a provisional actor-DB slice whose content/static details are still
   * loading — missing text renders as "…" rather than the settled "-".
   */
  isDetailsPending?: boolean;
  isEditing: boolean;
  onRemoveCard?: (graphemeCard: MorphemeDetailsTileSlice) => void;
}) {
  const studyPinyinList = usePrevalentPinyin(graphemeCard.front, graphemeCard.pinyinList);
  const getGraphemeGlyph = useGetGraphemeGlyph();
  const graphemeGlyph = getGraphemeGlyph(graphemeCard.front);
  const missingText = isDetailsPending ? "…" : "-";
  const pinyin =
    toDiacriticPinyinList(studyPinyinList.map(({ toneNumbersPinyin }) => toneNumbersPinyin)).join(
      ", ",
    ) || missingText;
  const gloss = graphemeCard.back || studyPinyinList[0]?.gloss || missingText;

  return (
    <View className="flex-row items-center gap-3 border-b border-border px-4 py-3">
      <GraphemeFontGlyph className="text-3xl text-foreground" glyph={graphemeGlyph} />
      <View className="flex-1">
        <Text className="text-sm text-muted-foreground">{pinyin}</Text>
        <Text className="text-base text-foreground" numberOfLines={1}>
          {gloss}
        </Text>
      </View>
      {isEditing && onRemoveCard ? (
        <Pressable
          accessibilityLabel={`Remove ${graphemeCard.front} from deck`}
          accessibilityRole="button"
          className="size-8 items-center justify-center rounded-xs border border-border bg-background"
          onPress={() => onRemoveCard(graphemeCard)}
        >
          <Icon color="#6B7280" name="MdDeleteOutline" size={16} />
        </Pressable>
      ) : null}
    </View>
  );
}
